import React from 'react';
import { Stack } from '@mui/material';
import { AssociatedClient } from '@/components/cards/DealCardValues/AssociatedClient';
import { useObjectContext } from '@/hooks/useObjectContext';
import { HeaderDetail } from './HeaderDetail';

export const DealSubtitle = () => {
	const { dealRow } = useObjectContext();

	const isClaim = dealRow?.pipeline === process.env.REACT_APP_PIPELINE_CLAIMS;
	const claimId = dealRow?.claimId;

	const getYearFolder = () => {
		const year = dealRow?.yearFolder;
		const years = (dealRow?.yearRoot ?? '').split('/');
		return (year ?? years[years.length - 1] ?? '').replace('-', '–');
	};
	const yearFolder = getYearFolder();

	return (
		<Stack role='heading' aria-level='2' direction='row' alignItems='center' spacing={3}>
			{isClaim && claimId && (
				<HeaderDetail label='ID' testId='claim-id'>
					{claimId}
				</HeaderDetail>
			)}
			<HeaderDetail label='Client'>
				<AssociatedClient hideHeader={true} />
			</HeaderDetail>
			{yearFolder && (
				<HeaderDetail label='Year' testId='year-folder'>
					{yearFolder}
				</HeaderDetail>
			)}
		</Stack>
	);
};
